<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}"> 
        <v-row>
            <v-col cols="12" align="center">
                <BatchesTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import BatchesTable from '@/components/lists/manufacturing/BatchesTable'
export default {
    name:'BatchesPage',
    components:{
        BatchesTable
    }
}
</script>